import React from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import CustomeDurationLabel from "../CustomeLabel/CustomeDurationLabel";
import getTimeDifference from "../TimeDifference";
import CustomeMilestone from "../CustomeLabel/CustomeMilestone";
import DownloadwithDisplayProper from "../FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../Modules/MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import CustomeCategoryandSubcategory from "../CustomeLabel/CustomeCategoryandSubcategory";
import { getSortNamePostType, decodeHtml } from "../../../assests/extention/commonfunction";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";

export default function ModelPostDetails({ setviewPost, posts, proposalmilestones }) {
  return (
    <div className="rent-product">
      <div className="modal-head">
        <h6>Post Details</h6>
        <button onClick={() => setviewPost((state) => !state)} className="btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
            alt=""
          />
        </button>
      </div>
      <div className="filter-detail justify-contnt-between">
        <div className="w-100">
          <h5>
            {decodeHtml(posts.title)} {getSortNamePostType(posts.type, posts?.is_bxp)}
          </h5>
          <div className="dollar-sec">
            <p>
              {/* <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                alt=""
              /> */}
              <GetPrice
                type={posts?.type}
                price={posts?.price}
                price2={posts?.price2}
                hiring_type={posts?.hiring_type}
              />
            </p>
            {/* <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                alt=""
              />
              Deadline:&nbsp;
              <CustomeDurationLabel
                duration={posts?.duration}
                duration_type={posts?.duration_type}
              />
            </p> */}
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                alt=""
              />
              Posted: {getTimeDifference(posts?.created_on)}
            </p>
          </div>
          <CustomeCategoryandSubcategory posts={posts} />
          {
            posts.language_title &&
            <div className="lang-sec">
              <h6>Preferred Language</h6>
              <h6>{posts.language_title}</h6>
            </div>
          }
          {/* <div className="lang-sec">
            <h6>Preferred language</h6>
            <p>{posts.language_title}</p>
          </div> */}
          <div className="lang-sec">
            <h6>Description</h6>
            <CustomReactQuillDescription value={posts.description} />
          </div>
          {
            posts.requirements &&
            <div className="lang-sec">
              <h6>Requirements</h6>
              <CustomReactQuillDescription value={posts.requirements} />
            </div>
          }
          {
            posts.terms &&
            <div className="lang-sec">
              <h6>Additional notes</h6>
              <CustomReactQuillDescription value={posts.terms} />
            </div>
          }

          {/* <div className="lang-sec">
            <h6>Competencies and expertise</h6>
            <div className="skills-expert">
              {posts.skills &&
                Array.isArray(posts.skills) &&
                posts.skills.map((item, index) => {
                  return <p key={index}> {item.title} </p>;
                })}
            </div>
          </div> */}
          {posts?.files &&
            Array.isArray(posts?.files) &&
            posts?.files?.length > 0 && (
              <div className="lang-sec">
                <h6>Attachments</h6>
                <div className="images">
                  {posts?.files &&
                    Array.isArray(posts?.files) &&
                    posts?.files.map((item, index) => {
                      return <DownloadwithDisplayProper item={item} />;
                    })}
                </div>
              </div>
            )}

          {posts?.deliverables && (
            <div className="lang-sec">
              <h6>Deliverables</h6>
              <CustomReactQuillDescription value={posts?.deliverables} />
            </div>
          )}

          <CustomeMilestone milestones={posts?.milestones} />

          <div className="lang-sec">
            {posts?.is_mine == 1 ? (
              <div className="  overview-center">
                <span>About Expert  </span>
                <div className="expert-left pt-2 d-flex " style={{ columnGap: '20px' }}>
                  <ProfileImageWithFallback url={proposalmilestones?.profile_image} style={{ height: "80px", width: "80px" }} />
                  <div>
                    <h2 style={{ fontSize: '30px' }}>
                      {decodeHtml(proposalmilestones?.first_name)} &nbsp;
                      {decodeHtml(proposalmilestones?.last_name)}
                    </h2>
                    <h6 className="pt-2">{decodeHtml(proposalmilestones?.designation)} </h6>
                    <h2>
                      <p>
                        <img
                          width={40}
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                          alt=""
                        />
                        Location: {proposalmilestones?.working_country_title}
                      </p>
                    </h2>
                    <p>
                      <i className="fa-solid fa-star"></i>
                      {proposalmilestones?.expert_rating || 0} (
                      {proposalmilestones?.expert_comment_count || 0} reviews)
                    </p>
                    {/* <p>Location: {proposalmilestones.location}</p> */}
                  </div>
                </div>

              </div>
            ) : (
              <div className="  overview-center expert-overdue-center">
                <span>About the Client</span>
                <div className="expert-left">
                  <ProfileImageWithFallback url={posts?.user?.profile_image} style={{ height: "80px", width: "80px" }} />
                  <div>
                    <h2>
                      {decodeHtml(posts?.user?.first_name)} {decodeHtml(posts?.user?.last_name)}
                    </h2>
                    <h6>{decodeHtml(posts?.user?.designation)} </h6>
                    <p>
                      <i className="fa-solid fa-star"></i>&nbsp;
                      &nbsp;{posts?.user?.rating} ({posts?.user?.reviews} reviews)
                    </p>
                    <p>
                      <img
                        width={40}
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                        alt=""
                      />
                      Location: {posts?.user?.country}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

// PREEMPTIVE HMR BURST
